import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../../../../Services/api';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';

const EstablishmentDetails = () => {
  const [data, setData] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
    const[division,setDivision] = useState([])
     const [selectedDivision, setSelectedDivision] = useState("NoDivision");

  const headers = [
    'Sl No',
    'Name of Contractor/Sub-Contractor',
    'Address',
    'Contact Person',
    'Contact No',
    'Escalation Contact No',
    'Email Id',
    'Escalation Email Id',
    'CLRA RC',
    'BOCW RC No',
    'No. of Workers',
    'Valid Date',
    'WC Policy Number',
    'No. of Workers Covered',
    'Valid Date',
    'ESI Number',
    'PF Number',
    'PSARA Licence',
    'Valid Date',
    'Factory Licence',
    'Valid Date',
    'GST Certificate',
    'Manager Change',
    'Shift Approval',
    'Hazardous waste Disposal Approval',
    'Boiler Amendment',
    'Biomedical Waste Approval',
    'Analysis Fee Payment',
    'Compliance Certificate',
    'Standing Order',
    'Trade Licence Reg And Renewal'
  ];

  let userData = sessionStorage.getItem('user');
  let corporateData = userData ? JSON.parse(userData) : null;
  let id = corporateData?.type === 'corporate' ? corporateData.id : null;


   useEffect(()=>{
            const getDivision = async () => {
          try{
              const response = await api.Corporate.getDivison(id);
              if(response.status === 200){
              setDivision(response.data.data);
              }
              else {
                  setDivision([])
              }
          }catch(error){
              console.error('Error fetching data', error  );
          }
      }
  
      getDivision()
      },[id])

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log(selectedDivision,"selecteddivion")
        if(selectedDivision === '' || selectedDivision === 'NoDivision'){
        const response = await api.client.getEstDetails(id);
        if (response.status === 200) {
          const result = response.data;
          if (Array.isArray(result.data.Profile)) {
            setData(result.data.Profile);
            setMasterData(result.data.MasterData);
          }
          setLoading(false);
        } else {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message || 'Error fetching data');
          setData([]);
          setLoading(false);
        }
      } 
      else {
         const response = await api.client.getEstDetails(id,selectedDivision);
        if (response.status === 200) {
          const result = response.data;
          if (Array.isArray(result.data.Profile)) {
            setData(result.data.Profile);
            setMasterData(result.data.MasterData);
          }
          setLoading(false);
        } else {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message || 'Error fetching data');
          setData([]);
          setLoading(false);
        }

      }
    }catch (error) {
        console.error('Error fetching data:', error);
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage('Network or server error');
        setData([]);
        setLoading(false);
      }
    };
    if (id) fetchData();
  }, [id,selectedDivision]);

  // 🔹 Shared value formatting logic
  const getDisplayValue = (field, fallback = 'NA') => {
    if (!field) return fallback;
    if (field.validation === 2 && field.na === true) return 'NA';
    if (field.validation === 3 && (field.value || field.noOfWorkers || field.validDate)) return 'NA';
    return field.value || field.noOfWorkers || field.validDate || fallback;
  };

 const handleExport = () => {
  const mappedData = data.map((item, index) => {
    const masterItem = masterData.find(master => master.companyId === item.companyId);

    return {
      'Sl No': index + 1,
      'Name of Contractor/Sub-Contractor': item?.clientName || 'NA',
      'Address': `${item?.clientAddress || ''}`,
      'Contact Person': item?.clientContactPersonName || 'NA',
      'Contact No': item?.clientContactPersonPhoneNumber || 'NA',
      'Escalation Contact No': item?.clientContactPersonPhoneNumber1 || 'NA',
      'Email Id': item?.clientContactPersonEmailId || 'NA',
      'Escalation Email Id': item?.clientContactPersonEmailId1 || 'NA',

      // CLRA
      'CLRA RC': getDisplayValue(masterItem?.CLRARC),

      // BOCW
      'BOCW RC No': getDisplayValue(masterItem?.BOCWRC),
      'BOCW No. of Workers': getDisplayValue({ ...masterItem?.BOCWRC, value: masterItem?.BOCWRC?.noOfWorkers }),
      'BOCW Valid Date': getDisplayValue({ ...masterItem?.BOCWRC, value: masterItem?.BOCWRC?.validDate }),

      // WC Policy
      'WC Policy Number': getDisplayValue(masterItem?.WCPolicyNumber),
      'WC No. of Workers Covered': getDisplayValue({ ...masterItem?.WCPolicyNumber, value: masterItem?.WCPolicyNumber?.noOfWorkers }),
      'WC Valid Date': getDisplayValue({ ...masterItem?.WCPolicyNumber, value: masterItem?.WCPolicyNumber?.validDate }),

      // ESI / PF
      'ESI Number': getDisplayValue(masterItem?.ESICAllotmentCopy),
      'PF Number': getDisplayValue(masterItem?.EPFOAllotmentCopy),      

      // PSARA
      'PSARA Licence': getDisplayValue(masterItem?.PSARALicence),
      'PSARA Valid Date': getDisplayValue({ ...masterItem?.PSARALicence, value: masterItem?.PSARALicence?.validDate }),

      // Factory Licence
      'Factory Licence': getDisplayValue(masterItem?.FactoryLicence),
      'Factory Valid Date': getDisplayValue({ ...masterItem?.FactoryLicence, value: masterItem?.FactoryLicence?.validDate }),

      // GST
      'GST Certificate': getDisplayValue(masterItem?.GSTCertificate),

      // Other Approvals
      'Manager Change': getDisplayValue(masterItem?.ManagerChange),
      'Shift Approval': getDisplayValue(masterItem?.ShiftApproval),
      'Hazardous Waste Disposal Approval': getDisplayValue(masterItem?.HazardouswasteDisposalApproval),
      'Boiler Amendment': getDisplayValue(masterItem?.BoilerAmendment),
      'Biomedical Waste Approval': getDisplayValue(masterItem?.BiomedicalWasteApproval),
      'Analysis Fee Payment': getDisplayValue(masterItem?.AnalysisFeePayment),
      'Compliance Certificate': getDisplayValue(masterItem?.ComplianceCertificate),
      'Standing Order': getDisplayValue(masterItem?.StandingOrder),
      'Trade Licence Reg And Renewal': getDisplayValue(masterItem?.TradeLicenceRegAndRenewal),
    };
  });

  // Extract headers from keys
  const headers = Object.keys(mappedData[0] || {});
  
  const ws = XLSX.utils.json_to_sheet(mappedData, { header: headers });
  XLSX.utils.sheet_add_aoa(ws, [headers], { origin: 'A1' });
  ws['!cols'] = headers.map(() => ({ wpx: 150 }));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Contractor Report');
  XLSX.writeFile(wb, 'Establishment Details.xlsx');
};

const handleDivisionChange = (event) =>{
const division = event.target.value
setSelectedDivision(division)
}

  return (
    <div>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
        <SnackbarContent style={{ backgroundColor: 'green' }} message={snackbarMessage} />
      </Snackbar>

      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={errorSnackbarOpen} autoHideDuration={3000} onClose={() => setErrorSnackbarOpen(false)}>
        <SnackbarContent style={{ backgroundColor: 'red' }} message={snackbarErrorMessage} />
      </Snackbar>

      <button className="btn btn-sm btn-danger mb-2" onClick={handleExport}>Download Excel</button>
                {division && division.length > 0 &&
    <select
    className='mx-4 mt-2 text text-dark'
        id="division"
        value={selectedDivision || ''}
        onChange={handleDivisionChange}
        style={{  border: "1px solid lightgray", padding: "5px", borderRadius: "4px" }}
      >
       <option value="" disabled>
        Select Division
       </option>
        <option value="NoDivision">
       Overall
       </option>
        {division.map((div, index) => (
          <option key={index} value={div}>
            {div}
          </option>
        ))}
      </select>
}
      <div style={{ minHeight: "380px", maxHeight: "400px", marginTop:"10px", overflowY: "auto" }}>
        <table style={{ width: '100%' }}>
          <thead className="position-sticky top-0" style={{ zIndex: 1000, backgroundColor: 'black', color: 'white', fontWeight: 'bold' }}>
            <tr>
              {headers.map((header, index) => (
                <th key={index} style={{ border: '1px solid white', padding: '8px' }}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((item, index) => {
                const masterItem = masterData.find(master => master.companyId === item.companyId);
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.clientName}</td>
                    <td>{item.clientAddress}</td>
                    <td>{item.clientContactPersonName}</td>
                    <td>{item.clientContactPersonPhoneNumber}</td>
                    <td>{item.clientContactPersonPhoneNumber1 || 'NA'}</td>
                    <td>{item.clientContactPersonEmailId}</td>
                    <td>{item.clientContactPersonEmailId1 || 'NA'}</td>
                    <td>{getDisplayValue(masterItem?.CLRARC)}</td>
                    <td>{getDisplayValue(masterItem?.BOCWRC)}</td>
                    <td>{getDisplayValue({ ...masterItem?.BOCWRC, value: masterItem?.BOCWRC?.noOfWorkers })}</td>
                    <td>{getDisplayValue({ ...masterItem?.BOCWRC, value: masterItem?.BOCWRC?.validDate })}</td>
                    <td>{getDisplayValue(masterItem?.WCPolicyNumber)}</td>
                    <td>{getDisplayValue({ ...masterItem?.WCPolicyNumber, value: masterItem?.WCPolicyNumber?.noOfWorkers })}</td>
                    <td>{getDisplayValue({ ...masterItem?.WCPolicyNumber, value: masterItem?.WCPolicyNumber?.validDate })}</td>
                    <td>{getDisplayValue(masterItem?.ESICAllotmentCopy)}</td>
                    <td>{getDisplayValue(masterItem?.EPFOAllotmentCopy)}</td>
                    <td>{getDisplayValue(masterItem?.PSARALicence)}</td>
                    <td>{getDisplayValue({ ...masterItem?.PSARALicence, value: masterItem?.PSARALicence?.validDate })}</td>
                    <td>{getDisplayValue(masterItem?.FactoryLicence)}</td>
                    <td>{getDisplayValue({ ...masterItem?.FactoryLicence, value: masterItem?.FactoryLicence?.validDate })}</td>
                    <td>{getDisplayValue(masterItem?.GSTCertificate)}</td>
                    <td>{getDisplayValue(masterItem?.ManagerChange)}</td>
                    <td>{getDisplayValue(masterItem?.ShiftApproval)}</td>
                    <td>{getDisplayValue(masterItem?.HazardouswasteDisposalApproval)}</td>
                    <td>{getDisplayValue(masterItem?.BoilerAmendment)}</td>
                    <td>{getDisplayValue(masterItem?.BiomedicalWasteApproval)}</td>
                    <td>{getDisplayValue(masterItem?.AnalysisFeePayment)}</td>
                    <td>{getDisplayValue(masterItem?.ComplianceCertificate)}</td>
                    <td>{getDisplayValue(masterItem?.StandingOrder)}</td>
                    <td>{getDisplayValue(masterItem?.TradeLicenceRegAndRenewal)}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={headers.length}>No Establishment found for this Corporate</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EstablishmentDetails;
